import DOMPurify from "dompurify";

/**
 * Safely sanitize HTML before rendering in React
 * @param {string} html
 * @returns {string} sanitized HTML
 */
export const sanitizeHtml = (html = "") => {
  if (!html || typeof html !== "string") return "";
  return DOMPurify.sanitize(html);
};
